import { render, staticRenderFns } from "./POSDialogs.vue?vue&type=template&id=6bbd7af5&scoped=true"
import script from "./POSDialogs.vue?vue&type=script&lang=js"
export * from "./POSDialogs.vue?vue&type=script&lang=js"
import style0 from "./POSDialogs.vue?vue&type=style&index=0&id=6bbd7af5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbd7af5",
  null
  
)

export default component.exports